export default __webpack_public_path__ + "static/media/facebook-circular-logo.2890b80d.svg";